import { HelpButton } from "@certn/auth";
import { showToast } from "@certn/cascadia";
import {
  BasicButton,
  DialogHeader,
  Dialog,
  Modal,
  PrimaryTopNav,
  DialogContent,
  DialogFooter,
  ModalTrigger,
  ButtonGroup,
  PrimaryButton,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useApplication } from "./ApplicationContext";
import { isQuickscreenBasePath } from "./utils";

interface Props {
  logo?: React.ReactNode;
  exitRedirectPath?: string;
}

export function ApplicationHeader(props: Props) {
  const navigate = useNavigate();
  const { partiallySaveData, basePath } = useApplication();
  const { t } = useTranslation();
  const isQuickscreen = isQuickscreenBasePath(basePath);

  const handleSaveAndExit = async () => {
    try {
      await partiallySaveData();
    } catch {
      showToast(t("Something went wrong"), { type: "error" });
      return;
    }

    navigate(props.exitRedirectPath || "/");
  };

  return (
    <PrimaryTopNav
      testID="applicant-portal-top-nav"
      logo={props.logo}
      onLogoPress={() => navigate("/")}
    >
      <HelpButton />
      <ModalTrigger>
        <BasicButton size="medium" testID="save-and-exit-button">
          <Trans>Save & exit</Trans>
        </BasicButton>
        <Modal>
          <Dialog>
            {({ close }) => (
              <>
                <DialogHeader onClose={close}>
                  {t("Are you sure you want to exit?")}
                </DialogHeader>
                <DialogContent>
                  {isQuickscreen ? (
                    <Trans>
                      There are steps remaining to complete this application.
                      Your progress has been saved.
                    </Trans>
                  ) : (
                    <Trans>
                      There are few steps remaining to complete your background
                      check. Your progress up until now has been saved.
                    </Trans>
                  )}
                </DialogContent>
                <DialogFooter>
                  <ButtonGroup>
                    <BasicButton size="medium" onPress={close}>
                      <Trans>Cancel</Trans>
                    </BasicButton>
                    <PrimaryButton size="medium" onPress={handleSaveAndExit}>
                      <Trans>Save & exit</Trans>
                    </PrimaryButton>
                  </ButtonGroup>
                </DialogFooter>
              </>
            )}
          </Dialog>
        </Modal>
      </ModalTrigger>
    </PrimaryTopNav>
  );
}
